import apiClient from '../apiClient';
import { GET_USER_PROFILE_ACCOUNT_MANAGER_URL } from '../apiUrl';

const getAccountManagerApi = () => {
  return apiClient.get(GET_USER_PROFILE_ACCOUNT_MANAGER_URL);
};

export default getAccountManagerApi;
